import { NavContext, SidebarTabs } from "@clockwise/web-commons/src/ui/home-nav/home-nav";
import classNames from "classnames";
import React, { useContext } from "react";
import { useOnboarding } from "../../hooks/useOnboarding/useOnboarding";
import { useFeatureFlag } from "../../launch-darkly";
import { canAccessExperiments } from "../../util/auth.util";

/**
 * @deprecated use AppNav
 */
export const WebNavigation = () => {
  const [hideFlexibleHolds] = useFeatureFlag("GatewayFlexibleMeetings");

  const { collapsed } = useContext(NavContext);
  const { shouldShowNUXChecklist } = useOnboarding();
  const sidebarClasses = "cw-flex-shrink-0 cw-h-auto";
  const sidebarOpenClasses = `cw-w-full cw-max-w-[270px] cw-transition cw-ease-in-out cw-overflow-x-hidden`;
  const sidebarClosedClasses = "cw-w-[72px] cw-transition cw-ease-in-out cw-overflow-x-hidden";

  return (
    <div
      className={classNames("cw-block", "cw-top-20 cw-static cw-bg-nav", sidebarClasses, {
        [sidebarOpenClasses]: !collapsed,
        [sidebarClosedClasses]: collapsed,
      })}
    >
      <SidebarTabs
        showExperiments={canAccessExperiments()}
        shouldShowGetStartedLandingPage={shouldShowNUXChecklist}
        hideFlexibleHolds={hideFlexibleHolds}
      />
    </div>
  );
};
